import { render, staticRenderFns } from "./role-auto-complete.vue?vue&type=template&id=f8cf6052&"
import script from "./role-auto-complete.vue?vue&type=script&lang=js&"
export * from "./role-auto-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports